export default __webpack_public_path__ + "static/media/Yenepoya.8372b7a1.png";